export const AdSlot = ({ label = "Publicidad", height = "h-[250px]", className = "" }) => (
  <div
    data-testid="ad-slot"
    className={`relative w-full ${height} bg-brand-adbg border-y border-brand-line/60 flex items-center justify-center my-8 overflow-hidden ${className}`}
  >
    <span className="absolute top-2 right-3 text-[10px] uppercase tracking-[0.2em] text-brand-sub/70">
      {label}
    </span>
    <span className="text-brand-sub/50 text-sm font-medium">Espacio publicitario · Google AdSense</span>
  </div>
);
